<template>
  <div>
    <nav aria-label="breadcrumb" class="content-block">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#/simpeg-dashboard">Dashboard</a>
        </li>
        <li class="breadcrumb-item">
          <a href="#/simpeg-pegawai-list">Daftar Pegawai</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">
          Daftar Riwayat Pendidikan
        </li>
      </ol>
    </nav>
    <div class="content-block">
      <h5>Daftar Riwayat Pendidikan</h5>
    </div>
    <div class="content-block">
      <div class="dx-card responsive-paddings">
        <DxDataGrid
          ref="gridRef"
          id="gridContainer"
          :data-source="dataSource"
          :allow-column-reordering="true"
          :show-borders="true"
          @editor-preparing="oneditorpreparing"
          :focused-row-index="0"
          :show-column-lines="false"
          :focused-row-enabled="true"
          :column-auto-width="true"
          :column-hiding-enabled="false"
          @option-changed="onPageChanged"
          @exporting="onExporting"
          :filter-sync-enabled="true"
          :remote-operations="true"
          :word-wrap-enabled="true"
          :height="gridHeight"
          :scrolling="{ mode: 'virtual' }"
        >
          <DxScrolling mode="virtual" row-rendering-mode="virtual" />

          <DxExport :enabled="true" :allow-export-selected-data="true" />

          <DxToolbar>
            <DxItem location="after" template="refresh-template" />
            <DxItem name="exportButton" />
            <DxItem name="columnChooserButton" />
          </DxToolbar>
          <template #refresh-template>
            <DxButton
              icon="refresh"
              @click="refreshDatagrid('gridRef')"
              text="Refresh Data"
              type="default"
              style="float: left"
              width="160px"
              styling-mode="outlined"
            ></DxButton>
          </template>
          <DxFilterRow :visible="showFilterRow" :apply-filter="currentFilter" />
          <dx-pager :show-page-size-selector="true" :show-info="true" />
          <DxPaging :enabled="true" :page-size="150" />
          <DxEditing
            :allow-updating="false"
            :allow-deleting="false"
            :allow-adding="false"
            mode="row"
          />
          <!-- <DxSelection mode="multiple" /> -->
          <DxColumnFixing :enabled="true" />
          <!-- <DxColumn
            caption="#"
            data-field="pegawai_id"
            cell-template="numberingTemplate"
            :allow-filtering="false"
            :allow-sorting="false"
          /> -->

          <template #numberingTemplate="{ data }">
            {{ numberingPageNumber * numberingPageSize + data.rowIndex + 1 }}
          </template>
          <DxColumn data-field="pegawai.nik" caption="NIK" data-type="string">
          </DxColumn>
          <DxColumn
            data-field="pegawai.nama"
            caption="Pegawai"
            data-type="string"
          >
          </DxColumn>
          <dx-column
            data-field="status_penyesuaian"
            caption="Penyesuaian"
            data-type="boolean"
          >
            <DxLookup
              display-expr="nama"
              value-expr="val"
              :data-source="statusPenyesuaianSource"
            />
            <!-- cell-template="penyesuaianTemplate" -->
          </dx-column>

          <dx-column
            data-field="tgl_penyesuaian"
            caption="Tgl Penyesuaian"
            :dataType="'date'"
            :display-format="'dd/MM/yyyy'"
            editor-type="dxDateBox"
            :format="'dd/MM/yyyy'"
          >
          </dx-column>
          <dx-column
            data-field="pendidikan_jenjang_id"
            caption="Jenjang"
            sort-order="asc"
            data-type="number"
          >
            <DxLookup
              display-expr="nama"
              value-expr="id"
              :data-source="pendidikanJenjangSource"
            />
            <DxRequiredRuleDataGrid />
          </dx-column>

          <DxColumn
            data-field="institusi"
            caption="Nama Institusi"
            data-type="string"
          >
          </DxColumn>
          <DxColumn data-field="fakultas" caption="Fakultas" data-type="string">
          </DxColumn>
          <DxColumn data-field="jurusan" caption="Jurusan" data-type="string">
          </DxColumn>
          <DxColumn data-field="ipk" caption="IPK" data-type="string">
          </DxColumn>

          <DxColumn
            data-field="tahun_mulai"
            caption="Tahun Mulai"
            data-type="number"
          />
          <DxColumn
            data-field="tahun_lulus"
            caption="Tahun Lulus"
            data-type="number"
          />
          <dx-column
            data-field="ijazah_no"
            caption="Nomor Ijazah"
            data-type="string"
          >
          </dx-column>
          <dx-column
            data-field="ijazah_tgl"
            caption="Tgl Ijazah"
            data-type="date"
            :display-format="'dd/MM/yyyy'"
            :format="'dd/MM/yyyy'"
            editor-type="dxDateBox"
          >
          </dx-column>

          <dx-column
            cell-template="diff-cell-template"
            :fixed="true"
            fixed-position="right"
            :allow-sorting="false"
            data-field="pegawai_id"
            data-type="number"
            caption=" "
            :allow-exporting="false"
            :allow-filtering="false"
          >
          </dx-column>

          <template #diff-cell-template="{ data }">
            <DxDropDownButton
              :items="options"
              icon="menu"
              :id="data.text"
              :show-arrow-icon="false"
              :drop-down-options="{ width: 100 }"
              @item-click="onItemClick"
            />
          </template>
        </DxDataGrid>
      </div>
    </div>
  </div>
</template>

<style lang="scss"></style>
<script>
import _ from "lodash";
import { ODATA_BASE_URL } from "@/global-constants";
import DxButton from "devextreme-vue/button";
import ODataStore from "devextreme/data/odata/store";
import DataSource from "devextreme/data/data_source";
import router from "@/router";
import DxDropDownButton from "devextreme-vue/drop-down-button";
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPaging,
  DxFilterRow,
  DxLookup,
  DxPager,
  DxExport,
  DxToolbar,
  DxItem,
  DxScrolling,
} from "devextreme-vue/data-grid";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";
import { usePendidikanJenjangStore } from "@/stores/PendidikanJenjangStore";
function getUrlFilter() {
  return router.currentRoute.value.query.filter;
}
const options = ["Detail"];

const dataSource = new DataSource({
  store: new ODataStore({
    // ODataStore is configured here
    url: `${ODATA_BASE_URL}/RiwayatPendidikans`,
    key: "id",
    version: 4,
    beforeSend: function (e) {
      e.headers = {
        "odata-version": "4.0",
      };
      console.log(e);

      if (typeof e.params.$filter == "undefined") {
        console.log("undefined");
        // e.params.$filter = "month(tgl) eq '5' and year(tgl) eq '2023'";
        e.params.$filter = getUrlFilter();
      }
      if (hasFilterNestedTable(e.params.$filter)) {
        e.params.$filter = convertFilterPegawai(e.params.$filter);
      }
      e.params.$orderby = "pegawai_id asc";
    },
  }),
  expand: ["pegawai"],
});

function hasFilterNestedTable(str) {
  return (
    _.includes(str, "/") ||
    _.includes(str, "[") ||
    _.includes(str, "]") ||
    _.includes(str, "riwayatPekerjaan/") ||
    _.includes(str, "riwayatGolongan/") ||
    _.includes(str, "pegawai/") ||
    _.includes(str, "pegawai/")
  );
}

function convertFilterPegawai(filter) {
  var searchTerm = (filter.match(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/
  ) || [])[1];
  var replacedString = filter.replace(
    /contains\(tolower\(pegawai\/nama\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nama),'${searchTerm}'))`
  );

  var searchTermNik = (replacedString.match(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/
  ) || [])[1];
  var replacedStringNik = replacedString;

  replacedStringNik = replacedString.replace(
    /contains\(tolower\(pegawai\/nik\),'([^']+)'/,
    `pegawai/any(s:(contains(tolower(s/nik),'${searchTermNik}'))`
  );

  return replacedStringNik;
}
export default {
  components: {
    DxDataGrid,
    DxColumn,
    DxEditing,
    DxPaging,
    DxFilterRow,
    DxLookup,
    DxPager,
    DxDropDownButton,
    DxButton,
    DxExport,
    DxToolbar,
    DxItem,
    DxScrolling,
  },
  setup() {
    const pendidikanJenjangStore = usePendidikanJenjangStore();
    return {
      pendidikanJenjangStore,
    };
  },

  data() {
    return {
      pendidikanJenjangSource: null,
      statusPenyesuaianSource: [
        { val: true, nama: "Penyesuaian" },
        { val: false, nama: "" },
      ],
      statusSource: [
        { val: true, nama: "Aktif" },
        { val: false, nama: "Tidak Aktif" },
      ],
      numberingPageSize: 10,
      numberingPageNumber: 0,
      router: router,
      options: options,
      // pegawaiSource: new ODataStore({
      //   url: "http://127.0.0.1/odata/pegawais",
      //   key: "id",
      // }),
      filterValue: "",
      dataSource,
      editingOptions: {},
      showFilterRow: true,
      currentFilter: [
        {
          key: "auto",
          name: "Immediately",
        },
      ],
      filterOperations: ["=", "<>", ">", "<", "between"],
      calculateFilterExpression: function (
        filterValue,
        selectedFilterOperation,
        target
      ) {
        console.log("calculateFilterExpression filterValue", filterValue);
        console.log(
          "calculateFilterExpression selectedFilterOperation",
          selectedFilterOperation
        );
        console.log("calculateFilterExpression target", target);
        let column = this;
        if (selectedFilterOperation === "=" && target == "filterRow") {
          console.log("calculateFilterExpression", "masuk ==");

          let bulan = filterValue.getMonth() + 1;
          var filterExpression = [
            "month(" +
              column.dataField +
              ") eq " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") eq " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression;
        }
        if (selectedFilterOperation === "<>" && target == "filterRow") {
          //notequal
          let bulan = filterValue.getMonth() + 1;
          var filterExpression2 = [
            "month(" +
              column.dataField +
              ") ne " +
              bulan.toString() +
              " and " +
              "year(" +
              column.dataField +
              ") ne " +
              filterValue.getFullYear().toString(),
          ];
          return filterExpression2;
        }
        if (selectedFilterOperation === "<" && target == "filterRow") {
          //less than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression3 = [
            "year(tgl) lt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) lt " +
              bulan +
              ")",
          ];
          return filterExpression3;
        }
        if (selectedFilterOperation === ">" && target == "filterRow") {
          //greater than
          let bulan = filterValue.getMonth() + 1;
          var filterExpression4 = [
            "year(tgl) gt " +
              filterValue.getFullYear().toString() +
              " or (year(tgl) eq " +
              filterValue.getFullYear().toString() +
              " and month(tgl) gt " +
              bulan +
              ")",
          ];
          return filterExpression4;
        }

        if (selectedFilterOperation === "between" && target == "filterRow") {
          // (year(Date) eq 2022 and month(Date) ge 5) or (year(Date) eq 2023 and month(Date) le 6)
          let bulan1 = filterValue[0].getMonth() + 1;
          let bulan2 = filterValue[1].getMonth() + 1;

          var filterExpression5 = [
            "month(tgl) ge " +
              bulan1 +
              " and year(tgl) ge " +
              filterValue[0].getFullYear() +
              " and " +
              "month(tgl) le " +
              bulan2 +
              " and year(tgl) le " +
              filterValue[1].getFullYear(),
          ];
          console.log(filterExpression5);
          return filterExpression5;
        }

        // Invokes the default filtering behavior
        return column.defaultCalculateFilterExpression(arguments);
      },
      oneditorpreparing: function (e) {
        console.log("ONEDITORPREPARING");
        console.log(e);
        if (e.dataField === "tgl") {
          e.editorOptions.calendarOptions = {
            minZoomLevel: "year",
            maxZoomLevel: "year",
            displayFormat: "MM/yyyy",
            type: "month",
          };
        }
      },
    };
  },
  async mounted() {
    this.pendidikanJenjangSource = await this.pendidikanJenjangStore.get();
  },
  computed: {
    gridHeight() {
      // Calculate grid height based on your requirements
      return "80vh"; // Set the height to fill the viewport vertically
    },
  },
  methods: {
    onExporting(e) {
      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Sheet 1");

      exportDataGrid({
        component: e.component,
        worksheet,
        autoFilterEnabled: true,
      }).then(() => {
        workbook.xlsx.writeBuffer().then((buffer) => {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "Daftar Riwayat Pendidikan.xlsx"
          );
        });
      });
      e.cancel = true;
    },

    refreshDatagrid(gridRef) {
      this.$refs[gridRef].instance.getDataSource().reload();
    },
    onPageChanged(e) {
      if (e.fullName == "paging.pageIndex") {
        this.numberingPageSize = this.$refs.gridRef.instance.pageSize();
        this.numberingPageNumber = e.value;
      }
    },

    onItemClick(e) {
      let pegawaiId = e.element.id;

      // this.router.push({
      //   name: "simpeg-pegawai-detail",
      //   query: { id: pegawaiId },
      // });

      const url = this.$router.resolve({
        name: "simpeg-pegawai-detail",
        query: { id: pegawaiId },
      }).href;
      window.open(url, "_blank");
    },
  },
};
</script>
